import moment from "moment";
import DatePicker from "components/CSRAdmin/FormElements/DatePicker";
import { useTranslation } from "react-i18next";

export default function EndDate({ setValue, register, errors, startDate }) {
  const { t } = useTranslation();
  return (
    <DatePicker
      setValue={setValue}
      labelName={t("AgentCSR-Admin-EndDate-label")}
      register={register}
      name="endDate"
      min={moment().format("YYYY-MM-DD").toString()}
      errors={errors}
      validationsProps={{
        required: "This is a required field.",
        validate: {
          futureDate: (value) =>
            moment(value).isSameOrAfter(moment(startDate).format("YYYY-MM-DD"))
              ? null
              : "Must be a future date.",
        },
      }}
      validationMessage={errors?.endDate?.message}
    />
  );
}
